import React from 'react';
// import './Footer.css';  // जर separate file हवी असेल तर uncomment करा, पण मी inline style दिलं आहे

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: About / Quick Links */}
        <div className="footer-column">
          <h3>ग्रामपंचायत कापशी</h3>
          <p>पंचायत समिती डहाणू, जि. पालघर</p>
          <p>ISO 9001:2015 प्रमाणित</p>
          <ul className="quick-links">
            <li><a href="/aboutus">ग्रामपंचायत बद्दल</a></li>
            <li><a href="/devlopment">विकास कामे</a></li>
            <li><a href="/gallery">छायाचित्र</a></li>
            <li><a href="/contact">संपर्क</a></li>
          </ul>
        </div>

        {/* Column 2: Social Media */}
        <div className="footer-column social-column">
          <h3>आम्हाला फॉलो करा</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <img src="/images/facebook.png" alt="Facebook" className="social-icon" />
            </a>
            <a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <img src="/images/twitter.png" alt="X (Twitter)" className="social-icon" />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <img src="/images/instagaram.jpg" alt="Instagram" className="social-icon" />
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <img src="/images/youtube.png" alt="YouTube" className="social-icon" />
            </a>
          </div>
          
        </div>

        {/* Column 3: Contact & Helpline */}
        <div className="footer-column contact-column">
          <h3>संपर्क</h3>
          <p>ग्रामपंचायत कार्यालय</p>
          <p> <strong>7028416410 ||9881688840</strong></p>
          <p>तांत्रिक समस्या साठी संपर्क -Helpline No: 8805042257</p>
        </div>

        {/* Column 4: Government Logos */}
        <div className="footer-column logos-column">
          <h3>सरकारी दुवे</h3>
          <div className="gov-logos">
            <a href="https://swachhbharat.mygov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/swachh-bharat.png" alt="Swachh Bharat" />
            </a>
            <a href="https://digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/digital-india-logo.png" alt="Digital India" />
            </a>
            <a href="https://data.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/portal.jpg" alt="Open Government Data" />
            </a>
            <a href="https://www.india.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/mh_logo.png" alt="National Portal of India" />
            </a>
            <a href="https://www.mygov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/mygov.png" alt="MyGov" />
            </a>
            <a href="https://www.meity.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/Meity_logo.png" alt="MeitY" />
            </a>
            <a href="https://www.pmindia.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/pm-india-logo.jpg" alt="PM India" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar - Copyright & Credit */}
      <div className="footer-bottom">
        <div className="credit">
        Website Designed, Designed & Developed by NexGen BR Technologies Pvt. Ltd.<br />
        Content provided by Grampanchayat Office, Government of Maharashtra<br />
        © 2026 [Client Company Name]. All Rights Reserved. | Designed & Developed by NexGen BR Technologies Pvt. Ltd. <br></br>
        Technical issues and updates may require some time for resolution. 7038278133<b> <u> </u></b>
      </div>
      </div>

      <style>{`
        .footer {
          background: linear-gradient(to bottom, #001f3f, #004b8d); /* Navy gradient */
          color: #ffffff;
          padding: 60px 20px 20px;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .footer-container {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 40px;
        }

        .footer-column {
          text-align: center; /* Mobile साठी center, पण large screen वर left align करू शकता */
        }

        .footer-column h3 {
          font-size: 1.4rem;
          margin-bottom: 20px;
          color: #a8daf9; /* Light blue */
          font-weight: 700;
        }

        .footer-column p {
          font-size: 1rem;
          margin: 8px 0;
          opacity: 0.9;
        }

        .quick-links {
          list-style: none;
          padding: 0;
        }

        .quick-links li {
          margin: 10px 0;
        }

        .quick-links a {
          color: #a8daf9;
          text-decoration: none;
          transition: color 0.3s;
        }

        .quick-links a:hover {
          color: #ffffff;
          text-decoration: underline;
        }

        .social-icons {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .social-icon {
          width: 40px;
          height: 40px;
          transition: transform 0.3s, filter 0.3s;
        }

        .social-icon:hover {
          transform: scale(1.15);
          filter: brightness(1.2);
        }

        .gov-logos {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 20px;
        }

        .gov-logos img {
          height: 60px;
          width: auto;
          transition: transform 0.3s;
        }

        .gov-logos img:hover {
          transform: scale(1.1);
        }

        .footer-bottom {
          margin-top: 50px;
          padding-top: 30px;
          border-top: 1px solid rgba(255, 255, 255, 0.15);
          text-align: center;
          font-size: 0.95rem;
          opacity: 0.9;
        }

        .credit strong {
          color: #a8daf9;
        }

        @media (max-width: 768px) {
          .footer {
            padding: 40px 15px 20px;
          }
          .footer-column {
            text-align: center;
          }
          .gov-logos img {
            height: 50px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;